module.exports = __webpack_public_path__ + "static/media/11@1024w.c498525b.jpg";